import useMedia from 'use-media';

/**
 * Custom hook for detection mobile width.
 */
export default function useMobileWidth(): boolean {
  return useMedia({ maxWidth: 768 });
}
